import React from "react";
import { useAuthentication } from "../context/authentication";
import { useContacts } from "../context/contacts";
import { DottedMenu } from "../context/dropdownMenu/DropdownMenuProvider";
import { useToast } from "../context/toast";
import { ContactPayment } from "../utils/types";

interface Props {
  disabled?: boolean;
  contactPayment: ContactPayment;
}

const ContactPaymentActionsButton: React.FC<Props> = ({
  disabled,
  contactPayment
}) => {
  const { setModalWarningConfig } = useToast();
  const { wrapActionWithAuth } = useAuthentication();
  const { removeContactPayment } = useContacts();

  return (
    <DottedMenu
      disabled={disabled}
      text="Open payment actions"
      className="z-10"
      menuItems={[
        {
          text: "Remove payment",
          onClick: wrapActionWithAuth(() => {
            setModalWarningConfig({
              open: true,
              resolve: () => {
                removeContactPayment(contactPayment);
              }
            });
          })
        }
      ]}
    />
  );
};

export default ContactPaymentActionsButton;
